import { kBiColorValues } from '@euler/app/components/message/widgets/bi-visualization/functions/biColors';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiPalette, kBiPaletteColors } from '@euler/model/bi/viz';
import { memo } from 'react';
import { View } from 'react-native';

/** A palette's colors, in the order series take them. */
export const BiPaletteSwatch = memo(
  ({ palette, size = 10 }: { palette: BiPalette; size?: number }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ flexDirection: 'row', gap: rpx(3) }}>
        {kBiPaletteColors[palette].map(color => (
          <View
            key={color}
            style={{
              width: rpx(size),
              height: rpx(size),
              borderRadius: rpx(size / 2),
              backgroundColor: kBiColorValues[color],
            }}
          />
        ))}
      </View>
    );
  },
);
